import { Component, h, ComponentInterface, State, Prop, Element } from '@stencil/core';
import { guid } from 'utils';
import { AspectRatio } from 'global/image-loader';

@Component({
	tag: 'kdx-card-link',
	styleUrl: 'kdx-card-link.scss',
	shadow: false
})
export class StCardLink implements ComponentInterface {

	@Element() root: HTMLElement;

	@State() guid: string = guid();

	@Prop() imgSrc: string;
	@Prop() cardTitle: string;
	@Prop() hLevel: string = 'h2';
	@Prop() href: string = '#';
	@Prop() label: string;
	@Prop() linkText: string;
	@Prop() linkIcon: string = "chevron-right";
	@Prop() componentScope: string;
	@Prop() isSpeedbump: boolean = false;
	@Prop() hideImgOnMobile: boolean = false;
	@Prop({
		mutable: true,
		reflect: true,
	}) target: string;
	@Prop({
		mutable: true,
		reflect: true
	}) linkRel: string;

	componentWillLoad() {
		if (this.isSpeedbump) {
			this.target = '_blank';
			this.linkRel = 'noopener';
		}
		this.maintainImageAspectRatio();		
	}

	maintainImageAspectRatio() {
		const img: HTMLImageElement = this.root.querySelector('.card-photo img');
	
		if (img && img != null) {
			const aspectRatio = new AspectRatio({
				ratio: [275, 199], // Dimensions from design
				element: img
			});
		
			aspectRatio.maintain();
			}
	}

	titleHoverIn(e) {
		e.target.closest('.kdx-card').classList.add('hover');
	}

	titleHoverOut(e) {
		e.target.closest('.kdx-card').classList.remove('hover');
	}

	render() {
		return (
			<article aria-label={this.label} class={`kdx-card-link${this.componentScope ? ` ${this.componentScope}-card-link` : ''}${this.isSpeedbump ? ' speedbump-link' : ''}`}>
				<div class="kdx-card card">
					{this.imgSrc &&
						<div class={`card-photo ${this.hideImgOnMobile ? "hide-on-mobile" : null}`}>
							<kdx-lazy-img css-class="photo" img-src={this.imgSrc} img-alt={this.cardTitle}></kdx-lazy-img>					
						</div>
					}
					<div class="card-body">
						<this.hLevel class="card-title">
							<a
								class={`${this.isSpeedbump ? ' speedbump-link' : ''}`} 
								href={this.href} 
								aria-label={this.label ? this.label : `More info on ${this.cardTitle}`}
								target={this.target}
								rel={this.linkRel}
								onMouseEnter={this.titleHoverIn} 
								onMouseLeave={this.titleHoverOut} 
								onFocusin={this.titleHoverIn} 
								onFocusout={this.titleHoverOut}
							>
								{this.cardTitle}
								<kdx-icon icon={this.linkIcon}></kdx-icon>
							</a>
						</this.hLevel>
								
						<slot />
					</div>
					{this.linkText &&
						<div class="card-footer">
							<p>
								{this.linkText}
								{this.linkIcon
									?
										<span class="svg-icon">
											<kdx-icon icon={this.linkIcon} />
										</span> 
									:
										<span class="svg-icon">
											<kdx-icon icon={this.linkIcon} />
										</span>
								}
							</p>
						</div>
					}
				</div>
			</article>
		);
	}
}